import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";
import { Award } from "../../awards/shared";

@Component({
  selector: "product-award-form",
  templateUrl: "./product-award-form.component.html",
  styleUrls: ["./product-award-form.component.scss"],
})
export class ProductAwardFormComponent {
  @Input() form: FormGroup;
  @Input() awards: Array<Award> = [];

  constructor(public ft: FormToolsService) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-award-form/product-award-form.component.ts